import HomePage from "../components/Dashboard/HomePage";

const DashboardPage = () => {
  return <HomePage />;
};

export default DashboardPage;
